module.exports = __webpack_public_path__ + "static/media/SPATO_MENU-normal.d645dfce.png";